// ============================================
// 外部ファイル
// ============================================
import fadeInAnimatnion from '../animation/fadeInAnimation';
import logoRotateAnimation from '../animation/logoRotateAnimation';

(() => {
	// ============================================
	// 実行
	// ============================================
	// 外部ファイル
	fadeInAnimatnion();
	logoRotateAnimation(
		'data-rotate_icon',
		false
	);
})();